// src/config.js
export const BASE_URL = "https://gpsapp1-backend.vercel.app";